import { postRequest } from '../../utils'
import { authServiceUrl } from '../../urls'

export const postUserReq = (username, password) => postRequest(`${authServiceUrl}/admin/users`, { username, password })
